export const FIREWORKS_OPTIONS = {
	autoresize: true,
	opacity: 0.5,
	acceleration: 1,
	friction: 0.97,
	gravity: 1,
	particles: 50,
	traceLength: 3,
	traceSpeed: 10,
	explosion: 5,
	intensity: 10,
	flickering: 50,
	lineStyle: "round",
	hue: {
		min: 0,
		max: 360,
	},
	delay: {
		min: 10,
		max: 60,
	},
	rocketsPoint: {
		min: 10,
		max: 50,
	},
	lineWidth: {
		explosion: {
			min: 1,
			max: 3,
		},
		trace: {
			min: 1,
			max: 2,
		},
	},
	brightness: {
		min: 50,
		max: 80,
	},
	decay: {
		min: 0.015,
		max: 0.03,
	},
}